/**
 * Page footer.
 *
 * Converted verbatim from `public/index.html:528-556`.
 */

const WelcomeFooter = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-section">
        <img
          src="/public/static/pictures/logo_dark_web.png"
          alt="LungChat"
          className="footer-logo-light"
        />
        <img
          src="/public/static/pictures/logo_light_web.png"
          alt="LungChat"
          className="footer-logo-dark"
        />
      </div>
      <div className="footer-section">
        <h4>Quick Links</h4>
        <a href="#about">About</a>
        <a href="#team">Team</a>
        <a href="#faq">FAQ</a>
        <a href="/paper/iclr-2026" target="_blank" rel="noopener">
          Paper
        </a>
      </div>
      <div className="footer-section">
        <h4>Resources</h4>
        <a href="https://lungmap.net" target="_blank">
          LungMAP
        </a>
      </div>
      <div className="footer-section">
        <h4>Contact</h4>
        <a href="mailto:pankaj.rajdeo@cchmc.org,nathan.salomonis@cchmc.org,michal.kouril@cchmc.org">
          Email Us
        </a>
      </div>
    </div>
    <div className="footer-bottom">
      <p>
        ©<script>document.write(new Date().getFullYear())</script> LungChat. All
        rights reserved.
      </p>
      <p>
        Developed by the LungMAP Data Coordination Center at Cincinnati
        Children's Hospital Medical Center
      </p>
    </div>
  </footer>
);

export default WelcomeFooter;
